export const REACTION_TYPES = ['THUMBS_UP', 'HEART', 'LAUGH', 'FIRE', 'NERD'];

export const REACTION_EMOJI_BY_TYPE = {
  THUMBS_UP: '👍',
  HEART: '❤️',
  LAUGH: '😂',
  FIRE: '🔥',
  NERD: '🤓',
};

export function isReactionType(value) {
  return typeof value === 'string' && REACTION_TYPES.includes(value);
}

function normalizeReactionCount(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

export function parseReactionSummary(raw) {
  if (!raw || typeof raw !== 'object') {
    return {
      total: 0,
      counts: Object.fromEntries(REACTION_TYPES.map((type) => [type, 0])),
      topReactionTypes: [],
    };
  }

  const counts = Object.fromEntries(
    REACTION_TYPES.map((type) => [type, normalizeReactionCount(raw.counts?.[type])]),
  );
  const total = normalizeReactionCount(raw.total);
  const topReactionTypes = Array.isArray(raw.topReactionTypes)
    ? raw.topReactionTypes.filter(isReactionType)
    : [];

  return { total, counts, topReactionTypes };
}
